<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>

<div *ngIf="!isPageLoading" class=" {{themeService.themeCssClass}}">

  <div fxLayout="row" fxLayoutAlign="center center">
      <div>
        <mat-form-field class="test-admin">
          <mat-label>Test</mat-label>
            <mat-option *ngFor="let team of teams " [value]="team">{{team.id}}</mat-option>
        </mat-form-field>
      </div>
  </div>
</div>
